import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ContractOutgoingMail } from "../_types/contract-outgoing-mail";

@Injectable({
  providedIn: 'root',
})
export class ContractOutgoingMailsService extends Service<ContractOutgoingMail> {
  public override type = 'contractsOutgoingMails';
  public override url = 'attendance/contractsOutgoingMails';
}